export default "__VITE_ASSET__e08fd5c8__"